export default "__VITE_ASSET__5ce3ee08__"